import React from 'react';
import { Link } from 'react-router-dom';

import Show from 'components/detail/Show';
import SimpleShowLayout from 'components/detail/SimpleShowLayout';
import { TextField, NumberField } from 'components/field';

import { paymentDetailFrontPath } from './urls';
import linkToRecordByReplaceId from 'util/linkToRecordByReplaceId';

export const SubsPaymentReferenceField = (props) => {

    const payment_detail_url = linkToRecordByReplaceId(paymentDetailFrontPath, props.record['payment_reference']);

    return (<Link to={payment_detail_url} label="Payment">
            <TextField record={props.record} source="payment_reference" label="Payment"/>
        </Link>
    );
};


export const SubsOrderPaymentShow = (props) => {
    return (
        <Show {...props} actions={null}>
            <SimpleShowLayout>
                <TextField source="id" label="Reference"/>
                <TextField source="shop_id" label="Shop ID"/>
                <TextField source="owner_mobile" label="Owner Mobile" />
                <NumberField style={{textAlign: 'left'}} source="amount" label="Amount"/>
                <TextField source="payment_time" label="Payment Time"/>
                <TextField source="payment_type" label="Payment Type"/>
                <TextField source="status" label="Status"/>
            </SimpleShowLayout>
        </Show>
    )
};


// WEBPACK FOOTER //
// ./src/routes/subscription/SubsOrderPayment.js